import { Component, OnInit, HostListener, ChangeDetectionStrategy, AfterViewChecked, NgZone } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {  of as observableOf, interval } from 'rxjs';
import { take,  finalize, tap } from 'rxjs/operators';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { EmbryoService } from '../Services/Embryo.service';
import { MenuItems } from '../Core/menu/menu-items/menu-items';
import { TranslateService } from '@ngx-translate/core';
import { Meta, Title } from "@angular/platform-browser";

declare var $: any;

@Component({
  selector: 'app-main',
  templateUrl: './Main.component.html',
  styleUrls: ['./Main.component.scss']
})
export class MainComponent implements OnInit,AfterViewChecked {
   ngAfterViewChecked(): void {
      console.log("main component afterviewchecked");
   }
  
   timer = 0;
   isRtl: any;
   currentUrl : any; 

   constructor(private loader : LoadingBarService,
               public embryoService : EmbryoService, 
               public menuItems: MenuItems,
               public translate: TranslateService,
               private router: Router,
               meta: Meta,
               title: Title,
               public ngZone:NgZone) { 
      title.setTitle('Lontray Shop - Zaful in Turkey');

      meta.addTags([
         { name: 'author',   content: 'lontray'},
         { name: 'keywords', content: ' Zaful Ürünleri, E-Ticaret Sitesi '},
         { name: 'description', content: 'Zaful Ürünleri Türkiye, E-Ticaret Sitesi.' }
      ]);

      if(this.embryoService.isDirectionRtl.value) {

         this.isRtl = 'rtl';
      } else {
         this.isRtl = 'ltr';
      }

      this.router.events
        .subscribe((event) => {

          if (event instanceof NavigationEnd) {
            this.currentUrl = event.url;
          }
        });
   }

   ngOnInit() {
      this.startTimer();
      this.ngZone.runOutsideAngular(() => {
         window.addEventListener(
             'scroll',
             this.onScrollEvent.bind(this)
         );
     }); 
   }

   public startTimer() {

      this.timer = 0;
      interval(1000).pipe(
      take(3),
      tap(value => { this.timer = value + 1; }),
       finalize(() => this.loader.complete()),
      ).subscribe();

      // We're sure that subscription has been made, we can start loading bar service
      this.loader.start();
   }

   public hideSideNav() {

      this.embryoService.sidenavOpen = false;
   }

   public changeDirection() {

      if(this.isRtl == "rtl") {
         this.isRtl = "ltr";
         this.embryoService.isDirectionRtl.next(false) ;
      } else {
         this.isRtl = "rtl"
         this.embryoService.isDirectionRtl.next(true) ;
      }

      this.embryoService.featuredProductsSelectedTab = 0;
      this.embryoService.newArrivalSelectedTab = 0;
   }

   /**
    * On window scroll add class header-fixed.
    */
   
   //No need hostListener. Becouse we did the same in ngInit with zone (For better performance)
   // @HostListener('window:scroll', ['$event'])
   onScrollEvent($event){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollTop >= 200) {
           $("app-main").addClass("header-fixed");
       } else {
           $("app-main").removeClass("header-fixed");
       }
   }
}
